<template>
    <div class="main_body_goods">
        <!-- 上半部分 -->
        <div class="main_body_goods_top">
            <!-- 右侧 -->
            <div class="main_body_goods_rt">
                <!-- 标签页 -->
                <goods-tabs
                    v-if="tabs"
                    :tabs="tabs"
                    :parent-id="cate.id"
                    :num="num">
                </goods-tabs>
                <!-- 查看更多按钮 -->
                <el-button
                    v-else
                    type="text"
                    size="mini"
                    @click="$router.push({name:'plist',query:{id:cate.id}})">
                    <span>{{$t("message.main.more")}}</span>
                    <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
            </div>
            <!-- 左侧标题 -->
            <div class="main_body_goods_title">{{cate.cat_name}}</div>
        </div>
        <!-- 下半部分 -->
        <el-row :gutter="15">
            <el-col :span="5">
                <!-- 搭配广告 -->
                <div class="main_body_collocation">
                    <img :src="cate.image" alt="">
                </div>
            </el-col>
            <el-col :span="19">
                <goods-list
                    :goods="goods"
                    :show-more="showMore"
                    :parent-id="cate.id">
                </goods-list>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: [ "goods", "cate", "tabs", "num" ],
    computed: {
        showMore(){
            return !this.tabs
        },
    },
    components: {
        goodsTabs: () => import("@/components/mainBodyGoodsTabs"),
        goodsList: () => import("@/components/mainBodyGoodsList"),
    },
}
</script>

<style scoped>
/* 组件盒子 */
.main_body_goods{
    margin-top: 30px;
}

/* 上半部分盒子 */
.main_body_goods_top{
    margin-bottom: 10px;
}
/* 标题 */
.main_body_goods_title{
    color: #333;
    font-size: 24px;
}
/* 右侧盒子 */
.main_body_goods_rt{
    float: right;
}

/* 搭配 */
.main_body_collocation{
    width: 100%;
}
.main_body_collocation>img{
    max-width: 100%;
}
</style>
